export default __webpack_public_path__ + "static/media/Kampen om gården_ljudläggare_mixare.4ff88f60.jpeg";